import { render, staticRenderFns } from "./PatientGenderPercentage.vue?vue&type=template&id=cefe39d8&scoped=true"
import script from "./PatientGenderPercentage.vue?vue&type=script&lang=ts"
export * from "./PatientGenderPercentage.vue?vue&type=script&lang=ts"
import style0 from "./PatientGenderPercentage.vue?vue&type=style&index=0&id=cefe39d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefe39d8",
  null
  
)

export default component.exports